import { createFetch } from "../../../../../helpers/fetch/FetchRequest";
import { getCookie } from "../../../../../helpers/common";
import { authNotify, onAuthError, saveLocationForRedirect } from "../../../../../helpers/data/get/user";
import { API_OWN_CONNECT_STATUS_EXTERNAL } from "../../../../../settings/endpoints/user";
import { USER_ACCESS_TOKEN_NAME } from "../../../../../settings/global";

export function checkConnectionStatus(data, onSuccess, onError) {
    createFetch({
        URL: API_OWN_CONNECT_STATUS_EXTERNAL,
        method: 'POST',
        headers: {
            'Authorization': 'Bearer ' + getCookie(USER_ACCESS_TOKEN_NAME),
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
        onSuccess: data => {
            if (onSuccess) onSuccess(data)
        },
        onError: response => {
            if (data.status === 401) {
                saveLocationForRedirect();
                onAuthError();
                authNotify();
                return;
            }
            if (onError) onError(response)
        }
    })
}